import { render, staticRenderFns } from "./file-text.vue?vue&type=template&id=c526f0de"
import script from "./file-text.vue?vue&type=script&lang=js"
export * from "./file-text.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c526f0de')) {
      api.createRecord('c526f0de', component.options)
    } else {
      api.reload('c526f0de', component.options)
    }
    module.hot.accept("./file-text.vue?vue&type=template&id=c526f0de", function () {
      api.rerender('c526f0de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/research/curriculum-manage/components/file-text.vue"
export default component.exports